import React from 'react';
import './GoogleMap.css';

const GoogleMap = ({ 
  mapUrl, 
  title = 'Our Location', 
  height = 450, 
  borderRadius = 10,
  showTitle = true,
  showShadow = true,
  mapWidth = 'container',
  customWidth = 80,
  backgroundColor = '#ffffff',
  titleColor = '#2c2c2c',
  sectionPaddingTop = 40,
  sectionPaddingBottom = 40,
  shadowStyle = 'medium',
  settings = {} 
}) => {
  // Поддерживаем как прямые пропсы, так и объект settings для обратной совместимости
  const finalMapUrl = mapUrl || settings.mapUrl || '';
  const finalTitle = title || settings.mapTitle || 'Our Location';
  const finalHeight = height || settings.mapHeight || 450;
  const finalBorderRadius = borderRadius || settings.borderRadius || 10;
  const finalShowTitle = showTitle !== undefined ? showTitle : (settings.showTitle !== undefined ? settings.showTitle : true);
  const finalShowShadow = showShadow !== undefined ? showShadow : (settings.showShadow !== undefined ? settings.showShadow : true);
  const finalMapWidth = mapWidth || settings.mapWidth || 'container';
  const finalCustomWidth = customWidth || settings.customWidth || 80;
  const finalBackgroundColor = backgroundColor || settings.backgroundColor || '#ffffff';
  const finalTitleColor = titleColor || settings.titleColor || '#2c2c2c';
  const finalSectionPaddingTop = sectionPaddingTop || settings.sectionPaddingTop || 40;
  const finalSectionPaddingBottom = sectionPaddingBottom || settings.sectionPaddingBottom || 40;
  const finalShadowStyle = shadowStyle || settings.shadowStyle || 'medium';

  if (!finalMapUrl) {
    return (
      <div className="google-map" style={{ 
        backgroundColor: finalBackgroundColor,
        paddingTop: `${finalSectionPaddingTop}px`,
        paddingBottom: `${finalSectionPaddingBottom}px`
      }}>
        <div className="google-map__container">
          <div className="google-map__placeholder">
            <h3>🗺️ Google Map</h3>
            <p>Please add a Google Maps embed URL in the section settings.</p>
            <small>Go to Google Maps → Share → Embed a map → Copy the iframe src URL</small>
          </div>
        </div>
      </div>
    );
  }

  const containerStyle = {
    width: finalMapWidth === 'custom' ? `${finalCustomWidth}%` : '100%',
    margin: finalMapWidth === 'custom' ? '0 auto' : '0',
    backgroundColor: finalBackgroundColor,
    paddingTop: `${finalSectionPaddingTop}px`,
    paddingBottom: `${finalSectionPaddingBottom}px`,
  };

  const getShadowStyle = (shadowStyle) => {
    switch (shadowStyle) {
      case 'none': return 'none';
      case 'small': return '0 2px 8px rgba(0, 0, 0, 0.08)';
      case 'medium': return '0 8px 32px rgba(0, 0, 0, 0.1)';
      case 'large': return '0 16px 64px rgba(0, 0, 0, 0.15)';
      default: return '0 8px 32px rgba(0, 0, 0, 0.1)';
    }
  };

  const wrapperStyle = {
    height: `${finalHeight}px`,
    borderRadius: `${finalBorderRadius}px`,
    boxShadow: finalShowShadow ? getShadowStyle(finalShadowStyle) : 'none',
  };

  return (
    <div className="google-map" style={containerStyle}>
      <div className="google-map__container">
        {finalShowTitle && finalTitle && (
          <h2 className="google-map__title" style={{ color: finalTitleColor }}>
            {finalTitle}
          </h2>
        )}
        
        <div 
          className="google-map__wrapper"
          style={wrapperStyle}
        >
          <iframe
            src={finalMapUrl}
            className="google-map__iframe"
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={finalTitle}
            aria-label="Google Maps"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default GoogleMap;